import React from 'react'
import SwaggerUI from 'swagger-ui-react'
import 'swagger-ui-react/swagger-ui.css'
import apiSpec from '@/data/api-spec.json'

export function ApiDocsStandalone() {
  return (
    <html lang="de">
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Mission Solar API Documentation</title>
        <style>{`
          body {
            margin: 0;
            padding: 20px;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            background: #fafafa;
          }
          .swagger-ui .info .title {
            color: #1a202c !important;
          }
          .swagger-ui .scheme-container {
            background: #f7fafc;
            border: 1px solid #e2e8f0;
          }
        `}</style>
      </head>
      <body>
        <SwaggerUI
          spec={apiSpec}
          docExpansion="list"
          defaultModelsExpandDepth={1}
          displayRequestDuration={true}
          filter={true}
          showExtensions={false}
          showCommonExtensions={false}
          tryItOutEnabled={true}
          deepLinking={true}
          displayOperationId={false}
          defaultModelExpandDepth={1}
          supportedSubmitMethods={['get', 'post', 'put', 'delete', 'patch']}
        />
      </body>
    </html>
  )
}